import { useEffect, useRef } from 'react';

import { useAppVisible } from '../../lib/telegram/use-app-visible';

/**
 * Calls `reload` each time the app becomes visible again after being hidden (S9 R10; Proposal, to
 * be validated): E12 is not polled (master X8, M7 R4 poll Home and Positions only), but a trader
 * coming back to the tab sees the server's state. Never on mount: the reads load then anyway.
 */
export function useReloadWhenVisible(reload: () => void): void {
  const visible = useAppVisible();
  const wasVisible = useRef(visible);
  useEffect(() => {
    if (visible && !wasVisible.current) reload();
    wasVisible.current = visible;
  }, [visible, reload]);
}
